// config.js
// internal network
export const  API_HOST = "https://pandora.mmsoftware100.com"; //"http://localhost/pandora/public";
//export const  API_HOST = "http://localhost/pandora/public";
export const  FILE_HOST = API_HOST;
export const  API_VERSION = "/api/v1";
export const  API_ENDPOINT = API_HOST + API_VERSION;
export const  LOGIN_API_ENDPOINT = API_ENDPOINT + "/login";
export const  REGISTER_API_ENDPOINT = API_ENDPOINT + "/register";
export const  ARTICLE_API_ENDPOINT = API_ENDPOINT + "/articles";
export const  VOTE_API_ENDPOINT = API_ENDPOINT + "/votes";